import { z } from 'zod';
import { GenericLegalTransactionRelationshipSchema } from '../../GenericLegalTransactionRelationshipSchema';
import { initLegalTransactionRelationshipSkeleton } from '../../ILegalTransactionRelationship';
import { LegalTransactionRelationshipTypeEnum } from '../../LegalTransactionRelationshipTypeEnum';
import { IMemberSpouse, SpouseMemberSchema } from '../../Members/IMemberSpouse';
import {
  getEmptyMarriageRelationshipData,
  MarriageRelationshipDataSchema,
} from './ILegalTransactionRelationshipMarriageData';

export const IMarriageRelationshipSchema =
  GenericLegalTransactionRelationshipSchema(
    z.literal(LegalTransactionRelationshipTypeEnum.Marriage),
    z.literal(2).optional(),
    MarriageRelationshipDataSchema,
    SpouseMemberSchema
  );

export type IMarriageRelationship = Omit<
  z.infer<typeof IMarriageRelationshipSchema>,
  'Members'
> & {
  Members: IMemberSpouse[];
};

export function getEmptyMarriageRelationship(): IMarriageRelationship {
  return {
    ...initLegalTransactionRelationshipSkeleton(),
    Version: 2,
    idRelationshipType: LegalTransactionRelationshipTypeEnum.Marriage,
    data: getEmptyMarriageRelationshipData(),
    Members: [],
  };
}
